module.exports = __webpack_public_path__ + "img/inner1blur.a3d34a46.jpg";